import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _noop from "lodash/noop";
import { Dialog } from '@datacamp/waffles-modals';
import React, { useState } from 'react';
import FeedbackForm from '../FeedbackForm';
import { useTranslation } from '../useTranslation';
import RateFeedbackQuestion from './RateFeedbackQuestion';
import ThanksForRating from './ThanksForRating';
import { FeedbackRatingProps, FeedbackRatingStatus, OnRateFeedback } from './utils';

var FeedbackRating = function FeedbackRating(_ref) {
  var _ref$onRate = _ref.onRate,
      onRate = _ref$onRate === void 0 ? _noop : _ref$onRate,
      question = _ref.question,
      ratedMessage = _ref.ratedMessage,
      _ref$ratingStatus = _ref.ratingStatus,
      ratingStatus = _ref$ratingStatus === void 0 ? 'NONE' : _ref$ratingStatus,
      isVisible = _ref.isVisible;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      message = _useState4[0],
      setMessage = _useState4[1];

  var defaultQuestion = t('FeedbackRating.defaultQuestion');
  var defaultRatedMessage = t('FeedbackRating.defaultRatedMessage');

  var onFeedbackMessageChange = function onFeedbackMessageChange(value) {
    setMessage(value);
  };

  var rateUseful = function rateUseful() {
    onRate({
      isUseful: true
    });
  };

  var rateNotUseful = function rateNotUseful() {
    onRate({
      isUseful: false,
      message: message
    });
  };

  var showModal = function showModal() {
    setMessage('');
    setModalVisible(true);
  };

  var exitModal = function exitModal() {
    if (ratingStatus === 'NONE') {
      rateNotUseful();
    }

    setModalVisible(false);
  };

  var getModalContent = function getModalContent() {
    switch (ratingStatus) {
      case 'NONE':
      case 'SAVING':
        return /*#__PURE__*/React.createElement(FeedbackForm.Input, {
          disabled: ratingStatus === 'SAVING',
          feedbackMessage: message,
          onCancel: rateNotUseful,
          onFeedbackMessageChange: onFeedbackMessageChange,
          onSubmit: rateNotUseful
        });

      case 'SAVED':
        return /*#__PURE__*/React.createElement(FeedbackForm.Success, {
          onClick: exitModal
        });

      case 'ERROR':
        return /*#__PURE__*/React.createElement(FeedbackForm.Failure, {
          buttonLabel: "Close",
          onClick: exitModal
        });

      default:
        return false;
    }
  };

  if (isVisible !== true) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "dc-sct-feedback__footer"
  }, ratingStatus === 'SAVED' || ratingStatus === 'SAVING' ? /*#__PURE__*/React.createElement(ThanksForRating, {
    ratedMessage: ratedMessage !== null && ratedMessage !== void 0 ? ratedMessage : defaultRatedMessage
  }) : /*#__PURE__*/React.createElement(RateFeedbackQuestion, {
    onRateNotUseful: showModal,
    onRateUseful: rateUseful,
    question: question !== null && question !== void 0 ? question : defaultQuestion
  }), /*#__PURE__*/React.createElement(Dialog, {
    isOpen: modalVisible,
    onClose: exitModal,
    width: 350
  }, getModalContent()));
};

export default FeedbackRating;